import script from "./KUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./KUploader.vue?vue&type=script&setup=true&lang=js"

import "./KUploader.vue?vue&type=style&index=0&id=73f18e78&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f18e78"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QFile});
